<template>
  <div id="wrapper">
    <div v-show="!loader">
      <div class="rcv_header">
        <h3 v-if="heading">{{ heading }}</h3>
        <div v-if="description" v-html="description"></div>
      </div>
      <div class="rcv">
        <div class="title">
          <div v-if="count">
            <p>
              {{
                count === 1 ? `${stepHeadingText}` : `${roundValue[count - 1]}`
              }}
            </p>
          </div>
        </div>
        <div class="chart-wrapper">
          <div class="barchart-icon">
            <v-icon
              :step="this.count"
              :colorvalue="iconColor"
              :colorname="iconName"
            />
			
          </div>

          <div class="barChart">
            <v-chart
              class="chart"
              ref="myEchart"
              :style="styleProps"
              :autoresize="true"
              :option="chartOptions"
            />
          </div>
          <div class="buttongroup-primary" aria-hidden="true">
            <v-button
              v-if="buttonLabels"
              v-on:onprevious="onprevious"
              v-on:onnext="onnext"
              :instruction="this.count"
              v-on:startover="initInitialGraph"
              v-on:onreset="resetGraph"
              :disable="disablestart"
              :oftest="ofText"
              :buttonText="buttonLabels"
            />
          </div>

        </div>

        <v-instructions
          v-if="instructionSet"
          :instruction="this.count"
          :disable="disablestart"
          :instructioncontent="instructionSet"
          ref="instruction"
        />

        <v-button
          v-if="buttonLabels"
          v-on:onprevious="onprevious"
          v-on:onnext="onnext"
          :instruction="this.count"
          v-on:startover="initInitialGraph"
          v-on:onreset="resetGraph"
          :disable="disablestart"
          :oftest="ofText"
          :buttonText="buttonLabels"
        />
      </div>
    </div>
    <div v-show="loader">
	
      <div class="loader">
        <div class="dot-loader"></div>
        <div class="dot-loader dot-loader--2"></div>
        <div class="dot-loader dot-loader--3"></div>
    </div>

    </div>
  </div>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import InstructionComponent from "./components/InstructionComponent";
import ButtonComponent from "./components/ButtonComponent";
import IconComponent from "./components/IconComponent";
import axios from "axios";
import {
  customColors,
  stepFivePurpleColors,
  stepFiveOrangeColors,
  getChartConfig,
  formatRounds,
  isSmallScreen
} from "./config/chart-config";

import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from "echarts/components";

import { getAppConfig, getInitialRoundObj } from "./config/app-config";
import VChart, { THEME_KEY } from "vue-echarts";
import * as echarts from "echarts";

use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
]);

const chartConfig = getChartConfig({
  stepValue: this.count,
  hasVotingEnded: false,
  axisdata: this.rowHeader,
  winnerText: this.winnerText
});
let appData = getAppConfig();
let ballotWinnerTimer;

export default {
  name: "Rcv",
  //count ->Current step
  data() {
    return {
      direction: null,
      count: 1,
      final: null,
      updatedOption: [],
      disablestart: false,
      styleProps: null,
      heading: "",
      description: "",
      stepHeadingText: "",
      ofText: "",
      instructionSet: null,
      rowHeader: null,
      winnerText: "",
      buttonLabels: null,
      label: "",
      roundValue: null,
      loader: true,
      chartOptions: null,
      iconColor: [],
      iconName: [],
    };
  },
  components: {
    "v-instructions": InstructionComponent,
    "v-button": ButtonComponent,
    "v-icon": IconComponent,
    VChart
  },
  watch: {
    count: function(newCount, oldCount) {
      this.initUpdateOption();
    }
  },
  methods: {
    //On clicking previous ,previous logic is handling here
    onprevious: function() {
      this.goTo();

      this.disablestart = false;
      this.count = this.count - 1;
      this.direction = "prev";
      if (this.count < 1) {
        this.count = 1;
      }
      //initing the graph with updated changes

      this.initUpdateOption();
    },

    //used to initing the graph with latest option
    initUpdateOption: function() {
      let updatedOption;
      const eliminatedOpacity = 0.2;
      const afterEliminationOpacity = 0.05;

      updatedOption = [...appData].map(round => {
        return {
          ...round,
          data: round.data.map((dataObj, index) => {
            if (index == 4) {
              if (this.count === 3) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: eliminatedOpacity
                };
              }
              if (this.count === 2) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: 1
                };
              }
            }

            if (index === 3) {
              if (this.count === 4) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: eliminatedOpacity
                };
              }
              if (this.count === 3) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: 1
                };
              }
            }

            if (index === 6) {
              if (this.count === 5) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: eliminatedOpacity
                };
              }
              if (this.count === 4) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: 1
                };
              }
            }

            if (index === 2) {
              if (this.count === 6) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: eliminatedOpacity
                };
              }
              if (this.count === 5) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: 1
                };
              }
            }

            return dataObj;
          })
        };
      });

      if (this.count == 6) {
        ballotWinnerTimer = setTimeout(() => {
          this.final = true;
          updatedOption = appData.map(round => {
            return {
              ...round,
              data: round.data.map((dataObj, index) => {
                if (index === 1) {
                  dataObj.itemStyle = {
                    ...dataObj.itemStyle,
                    color: customColors[1]
                  };
                }
                if (index === 2) {
                  dataObj.itemStyle = {
                    ...dataObj.itemStyle,
                    opacity: afterEliminationOpacity
                  };
                }
                if (index === 3) {
                  dataObj.itemStyle = {
                    ...dataObj.itemStyle,
                    opacity: afterEliminationOpacity
                  };
                }
                if (index === 4) {
                  dataObj.itemStyle = {
                    ...dataObj.itemStyle,
                    opacity: afterEliminationOpacity
                  };
                }
                if (index === 5) {
                  dataObj.itemStyle = {
                    ...dataObj.itemStyle,
                    color: customColors[5]
                  };
                }
                if (index === 6) {
                  dataObj.itemStyle = {
                    ...dataObj.itemStyle,
                    opacity: afterEliminationOpacity
                  };
                }
                return dataObj;
              })
            };
          });
          this.disablestart = false;
          this.updateGraph(updatedOption);
        }, 1500);
      }
      if (this.count === 5 && this.direction === "prev") {
        this.final = false;
        updatedOption = appData.map((round, index) => {
          round.data[1] = {
            ...round.data[1],
            itemStyle: {
              color: stepFivePurpleColors[index]
            }
          };
          round.data[5] = {
            ...round.data[5],
            itemStyle: {
              color: stepFiveOrangeColors[index]
            }
          };
          return round;
        });
      }
      updatedOption = appData.map((round, roundIndex) => {
        if (roundIndex > this.count) {
          return {
            ...round,
            data: round.data.map(dataObj => {
              return {
                ...dataObj,
                value: 0
              };
            })
          };
        }
        return round;
      });

      this.updateGraph(updatedOption);
    },

    //on clicking the next, next logic is handlling here
    onnext: function() {
      this.goTo();
      this.direction = "next";
      this.final = false;

      // this.disablestart = false;
      let vm = this;
      this.count = this.count + 1;
      if (this.count > 5) {
        this.count = 6;
        this.disablestart = true;
      }

      this.initUpdateOption();
    },

    //initializing the initial graph
    initInitialGraph: function() {
      this.goTo();
      this.disablestart = false;

      this.count = 0;
      this.count = this.count + 1;
      const round0 = getInitialRoundObj();
      this.updatedOption = { ...round0, hasVotingEnded: false };
      this.graphInitor();
    },

    goTo: function() {
      let element = document.getElementById("wrapper");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "center"
        });
      }
      //   if (this.$refs.instruction) {
      //     this.$refs.instruction.$el.focus();
      //   }
    },

    //reseting the graph when the start is clicked
    resetGraph: function() {
      // this.disablestart = false;
      this.goTo();

      const initialRound = getInitialRoundObj();
      appData = getAppConfig();
      const chartOptions = {
        ...chartConfig,
        series: initialRound
      };
      // this.updatedOption = chartOptions;
      this.chart = this.$refs.myEchart;
      this.count = 0;
      this.count = this.count + 1;
      this.chart.setOption({}, true);
      this.chart.setOption(chartOptions, true);
    },

    // initializing the graph with updated option
    updateGraph: function(updatedOption) {
      var currentOption = [];
      if (this.count == 1) {
        currentOption = updatedOption.slice(0, this.count);
      } else if (this.count == 6 && this.final == true) {
        currentOption = updatedOption.slice(6, 7);
      } else {
        currentOption = updatedOption.slice(1, this.count);
      }

      const updatedBallotRounds = formatRounds(
        currentOption,
        this.count,
        this.label
      );

      this.updatedOption = updatedBallotRounds;
      const stepValue = this.count;
      let hasVotingEnded = false;
      if (this.updatedOption[0] != null) {
        hasVotingEnded = this.updatedOption[0].hasVotingEnded;
        if (this.count == 6 && this.final == true) {
          hasVotingEnded = true;
        }
      }
    
      const axisData = this.rowHeader;
      const winnerText = this.winnerText;
      const chartConfig = getChartConfig({
        stepValue,
        hasVotingEnded,
        axisData,
        winnerText
      });
      const updatedOptions = {
        ...chartConfig,
        series: updatedBallotRounds
      };

      if (Object.keys(this.$refs).length > 0) {
        this.chart = this.$refs.myEchart;

        this.chart.setOption(updatedOptions, {
          notMerge: true,
          lazyUpdate: false,
          silent: false
        });
      }
    },

    //initializing the graph with default value
    graphInitor: function() {
      const stepValue = this.count;
      const ballotRounds = this.updatedOption;
      const hasVotingEnded = this.updatedOption.hasVotingEnded;
      const chartConfig = getChartConfig({ stepValue, hasVotingEnded });
      const chartOptions = {
        ...chartConfig,
        series: ballotRounds
      };

      this.chart = this.$refs.myEchart;
      this.chart.setOption(chartOptions, true);
    }
  },

  created() {
    this.styleProps = isSmallScreen
      ? { width: "100%", height: "443px" }
      : { width: "97%", height: "576px" };
    let currentInstance = this;
    let cultureDefault = document.documentElement.lang;
    let culture = document.getElementById("ApplicationCulture").value;
    let recvDemo = document.getElementsByClassName("hdnrcvcontentid")[0].value;
    let url="";
    
    if(culture!=null)
    {
      url = `${location.origin}/rcvapi/getrcvpracticedemo?pageId=${recvDemo}&culture=${culture}`;
    }
    else
    {
      url = `${location.origin}/rcvapi/getrcvpracticedemo?pageId=${recvDemo}&culture=${cultureDefault}`;
    }
    
    const axios = require("axios");
    currentInstance.axios
      .get(url, {})
      .then(response => {
        currentInstance.loader = true;
        if (response.status == 200) {
          var responseData = response.data.responseObject;
        
          currentInstance.heading = responseData.heading;
          currentInstance.description = responseData.description;
          currentInstance.stepHeadingText = responseData.stepHeadingText;
          currentInstance.ofText = responseData.ofText;
          currentInstance.instructionSet = responseData.steps;
          let yCordinates = responseData.rowHeaders.map(function(item) {
            return item.label;
          });
          let roundValue = responseData.steps.map(function(item) {
            return item.stepTitle;
          });
          currentInstance.roundValue = roundValue;
          currentInstance.rowHeader = ["null", ...yCordinates];
          if (responseData.resultText !== "") {
            let modifiedString = responseData.resultText.replace("\\n", "\n");
            currentInstance.winnerText = modifiedString;
          }

          currentInstance.buttonLabels = responseData.buttonLabels;
          currentInstance.label = responseData.voteText;

          //    let labelColor = responseData.rowHeaders.map(function(item) {
          //     return item.color;
          //   });
          let labelColor = [
            "#221649",
            "#4BA3B7",
            "#367D54",
            "#FADE4B",
            "#EB5534",
            "#ED7ACA"
          ];
          currentInstance.iconColor = labelColor;
          currentInstance.iconName = yCordinates;
          setTimeout(function() {
            currentInstance.initUpdateOption();
            currentInstance.loader = false;
          }, 1000);
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  mounted() {
    this.count = 1;
  },

  unmounted() {
    if (ballotWinnerTimer !== undefined) {
      clearTimeout(ballotWinnerTimer);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/Rcv.vue